import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

import { IonicModule, PopoverController } from '@ionic/angular';
import { UtilsService } from '../../../core/services/utils.service';
import { AGENTS, RESPONSE_STATUS, TASK_STATUSES } from '../../../core/constants/enums';
import { filter, interval, map, Subject, takeUntil, tap } from 'rxjs';
import { SubmitTaskResponse } from '../../../core/models/submit-task-response';
import { RefactorService } from '../../../coding/refactor/services/refactor.service';
import { ManualtestsService } from '../../../no-coding/manual-tests/services/manualtests.service';
import { UnitTestService } from '../../../coding/unit-tests/services/unit-test.service';
import { AnalysisService } from '../../../coding/refactor/services/analysis.service';
import { HttpErrorResponse } from '@angular/common/http';
@Component({
  selector: 'app-progress-modal',
  templateUrl: './progress-modal.component.html',
  styleUrls: ['./progress-modal.component.scss'],
  standalone: false
})
export class ProgressModalComponent implements OnInit {
  @Input() agent!: string;
  @Input() taskId!: string;
  @Input() showSpinner = true;
  // @Input() progress = 0; // número entre 0 y 100
  @Input() showProgressBar = true;
  @Input() showStopButton = true;
  @Input() showRestartButton = true;
  @Input() showCloseButton = true;
  @Input() message = 'ESTAMOS HACIENDO EL TRABAJO';
  @Input() manageTask = true;

  taskStatus$ = new Subject<string>();
  taskStatus = '';
  percentaje$ = new Subject<number>();
  progress: number = 0;
  responseStatusEnum = RESPONSE_STATUS;
  completed = false;
  response!: SubmitTaskResponse;
  stop$ = new Subject<void>();
  service!: RefactorService | ManualtestsService | UnitTestService | AnalysisService;
  spinning = true;
  successMessage = '';
  errorMessage = '';
  showContinueButton = false;

  constructor(
    private utilsService: UtilsService,
    private popoverController: PopoverController,
    private refactorService: RefactorService,
    private testPlanService: ManualtestsService,
    private unitTestService: UnitTestService,
    private analysisService: AnalysisService) {

  }
  ngOnInit(): void {
    this.getAgentService();
    this.percentaje$.subscribe((data) => this.progress = data);
    if (this.manageTask) {
      this.checkTaskProcess();
      this.getCompleted();
    }
  }

  onStopClick(): void {
    this.service.stop(this.taskId).subscribe({
      next: (response: boolean) => {
        if (response) {
          console.log('Tarea parada', this.taskId);
          this.stop$.next();
          this.stop$.complete();
          this.popoverController.dismiss({ result: false });
        }
      },
      error: (error: HttpErrorResponse) => {
        this.manageError();
        this.stop$.next();
        this.stop$.complete();
      }
    });
  }

  onRestartClick(): void {
    this.stop$.next();
    this.stop$.complete();
    this.popoverController.dismiss({ result: false, isRestarting: true });
  }

  onCloseClick(): void {
    this.service.stop(this.taskId).subscribe({
      next: (response: boolean) => {
        if (response) {
          console.log('Tarea parada', this.taskId);
          this.errorMessage = '';
        }
      }
    });
    this.stop$.next();
    this.stop$.complete();
    this.popoverController.dismiss({ result: false });
  }

  onContinueClick(): void {
    this.popoverController.dismiss({ result: true });
  }

  checkTaskProcess(): void {
    interval(1500)
      .pipe(
        map(() => {
          this.utilsService
            .getTaskStatus(this.taskId, this.agent)
            .pipe(tap((data) => this.percentaje$.next(data.progress)))
            .pipe(
              filter(
                (data) =>
                  data.status === TASK_STATUSES.COMPLETED ||
                  data.status === TASK_STATUSES.FAILED
              )
            )
            .subscribe(
              {
                next: (resp) => {
                  this.stop$.next();
                  this.stop$.complete();
                  this.percentaje$.complete();
                  this.taskStatus$.next(resp.status);
                },
                error: (error: HttpErrorResponse) => {
                  this.stop$.next();
                  this.stop$.complete();
                  this.percentaje$.complete();
                  this.manageError();
                  // this.popoverController.dismiss({result: false});
                }
              });
        })
      )
      .pipe(takeUntil(this.stop$))
      .subscribe((data) => { });
  }

  getCompleted() {
    this.taskStatus$.subscribe({
      next: (data) => {
        this.taskStatus = data;
        if (this.taskStatus === TASK_STATUSES.FAILED) {
          this.taskStatus$.complete();
          this.taskStatus$ = new Subject<string>();
          this.completed = true;
          this.manageError();
          return;
        }
        this.showProgressBar = false;
        this.showSpinner = false;
        this.showStopButton = false;
        this.showContinueButton = true;
        this.successMessage = '¡Operación realizada con éxito!';
      },
      error: (error) => {
        console.error('Error en taskStatus$', error);
        this.manageError();
      },
    });
  }

  getAgentService() {
    switch (this.agent) {
      case AGENTS.REFACTOR:
        this.service = this.refactorService;
        break;
      case AGENTS.UNITTEST:
        this.service = this.unitTestService;
        break;
      case AGENTS.TESTPLAN:
        this.service = this.testPlanService;
        break;
      case AGENTS.ANALYSIS:
        this.service = this.analysisService;
        break;
      default:
        this.service = this.refactorService;
        break;
    }
  }

  manageError() {
    this.spinning = false;
    this.showRestartButton = true;
    this.showStopButton = false;
    this.showProgressBar = false;
    this.showSpinner = false;
    this.errorMessage = 'Ha ocurrido un error en el proceso. Inténtelo de nuevo.';
  }
}
